import { SubstitutionConditionDto } from ".";

export class SubstitutionDto {
	id: number;

    playerIn: number;
	
	playerOut: number;
	
	minute: SubstitutionConditionDto;
	
	score: SubstitutionConditionDto;
	
	mark: SubstitutionConditionDto;
	
	position: number;
	
	physic: SubstitutionConditionDto;
	
	isYellowCard: boolean;
}